import React, { FC, Fragment } from "react"

import { Props } from "./types"
import * as styles from "./styles.module.scss"
import Accordion from "src/components/Accordion"

const CommonQuestions: FC<Props> = ({
  markdowns,
  title,
  sectionTitle = true,
  className,
}) => {
  return (
    <div className={`${styles.commonQuestions} ${className}`}>
      {title && <h2 className={styles.commonQuestionsTitle}>{title}</h2>}
      {markdowns.map(section => (
        <div key={section.id} className={styles.section} id={section.id}>
          {section.name && sectionTitle && (
            <h3 className={`${styles.sectionTitle} anchor-fixed-header-offset`}>
              {section.name}
            </h3>
          )}
          <hr className={`separator ${styles.separator}`} aria-hidden="true" />
          {section.questions.map(({ content, id, title }) => (
            <Fragment key={id}>
              <Accordion title={title} content={content} />
              <hr
                className={`separator ${styles.separator}`}
                aria-hidden="true"
              />
            </Fragment>
          ))}
        </div>
      ))}
    </div>
  )
}

export default CommonQuestions
